import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime, distinctUntilChanged } from 'rxjs/operators';

@Directive()
export class Throttle implements OnInit, OnDestroy {
  @Input() throttleTime = 500;
  @Output() throttledClick = new EventEmitter();
  public clicks = new Subject<any>();
  public subscription: Subscription;

  ngOnInit() {
    this.subscription = this.clicks
      .pipe(throttleTime(this.throttleTime), distinctUntilChanged())
      .subscribe((e) => this.emitThrottledClick(e));
  }

  emitThrottledClick(e) {
    this.throttledClick.emit(e);
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
